import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import TimeDateTime from "csi/heading/TimeDateTime";
import declare from "dojo/_base/declare";
import _UTC from "./_UTC";

const WorkflowDate = declare(TimeDateTime, {
	bCopy: true,

	/**
	 * Set to true if you want to adjust a timestamp used in this widget to accomodate differences
	 * between timezone offsets of client and server timezones. See SiteAdmin/_UTC.ts for details.
	 */
	adjustClientServerTime: true,

	/** offset the date by TimeZoneOffsetMillis */
	fromHtmlDynamic(ctx: Context, h: Heading, editNode: Node): number {
		const value = this.inherited<number>(arguments);
		return this.adjustClientServerTime ? _UTC.clientToServer(value, (editNode as any).csiServerOffset) : value;
	},

	/** return value for widget */
	_addDynamicParams(ctx: Context, h: Heading, params: any): void {
		if (this.adjustClientServerTime) {
			params.csiServerOffset = _UTC.getServerOffset(ctx);
		}
		this.inherited(arguments);
	},

	_getValue(ctx: Context, h: Heading): number {
		const value = this.inherited<number>(arguments);
		return this.adjustClientServerTime ? _UTC.serverToClient(value, _UTC.getServerOffset(ctx)) : value;
	},

});

export = WorkflowDate;
